"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkButton = exports.AnchorButton = exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_router_dom_1 = require("react-router-dom");
const buttonSizing = (size) => {
    switch (size) {
        case 'lg':
            return 'px-8 py-2 leading-6 text-lg border-[3px]';
        case 'sm':
            return 'px-7 py-1 tracking-tight text-base tracking-7 border-2';
        default:
            return 'px-4 py-2 tracking-[1px] text-2xs uppercase border leading-3';
    }
};
const buttonStyling = (style) => {
    switch (style) {
        case 'solid':
            return 'bg-blue-5 border-blue-5 text-white';
        case 'reverse':
            return 'bg-white border-blue-5 text-blue-5';
    }
};
const buttonCorners = (corners) => {
    switch (corners) {
        case 'circle':
            return 'rounded-full';
        case 'pill':
            return 'rounded-full';
        case 'rounded':
            return 'rounded-lg';
        case 'none':
            return 'rounded-none';
    }
};
const getButtonStyle = ({ size = 'xs', appearance = 'solid', corners = 'pill' }, ...additional) => {
    return (0, classnames_1.default)('inline-block text-center font-semibold focus:outline-none focus:ring hover:border-blue-6 hover:bg-blue-6 hover:text-white disabled:text-grey-4 disabled:border-grey-2 disabled:bg-grey-2 focus:ring-blue-4/40', buttonSizing(size), buttonStyling(appearance), buttonCorners(corners), ...additional);
};
const Button = ({ onClick, children, type = 'button', disabled, size, appearance, corners, className, role, tracking, }) => {
    return (react_1.default.createElement("button", { type: type, onClick: onClick, disabled: disabled, className: getButtonStyle({ size, appearance, corners }, className, tracking), role: role }, children));
};
exports.Button = Button;
const AnchorButton = ({ children, href, target, onClick, size, appearance, corners, className, role, tracking, }) => {
    return (react_1.default.createElement("a", { href: href, className: getButtonStyle({ size, appearance, corners }, className, tracking), target: `_${target}`, rel: target === 'blank' ? 'noopener noreferrer' : undefined, role: role, onClick: onClick }, children));
};
exports.AnchorButton = AnchorButton;
const LinkButton = ({ children, to, onClick, size, appearance, corners, className, role, tracking, }) => {
    return (react_1.default.createElement(react_router_dom_1.Link, { to: to, className: getButtonStyle({ size, appearance, corners }, className, tracking), role: role, onClick: onClick }, children));
};
exports.LinkButton = LinkButton;
